import { useQuery } from '@tanstack/react-query';
import { listAssistantSessionsV2HousesHouseIdAssistantSessionsGetOptions } from '@/client/@tanstack/react-query.gen.ts';

/**
 * Fetches all past assistant sessions for a house, ordered most-recent-first.
 * Used by the chat history drawer to let users browse and resume past conversations.
 */
export const useAssistantSessions = (houseId: number, enabled = true) => {
	return useQuery({
		...listAssistantSessionsV2HousesHouseIdAssistantSessionsGetOptions({
			path: { house_id: houseId },
		}),
		// Session history changes whenever a turn creates or updates a conversation.
		// Keep it immediately stale so reopening the drawer always reconciles with the backend.
		staleTime: 0,
		enabled,
	});
};
